import { z } from 'zod'
import { IncomingMessage, ServerResponse } from 'http'
import { PlatformError } from '~/utils/errors'
import { getSession } from '../auth0'
import { logger } from '../logger'
// TODO: sort this location, move the old out of api-shared

export const UserIdSchema = z.string().max(20) // TODO: do we have more specifics on what this can be? For BA 8 digits, for EI 16 digits (in stage auth)

export const UNAUTHENTICATED_USER_ID = 'unauthenticated_user'

export const getUserId = async (req: IncomingMessage, res: ServerResponse) => {
  const session = await getSession(req, res)

  if (!session) {
    logger.info('Valid user session not found')
    return UNAUTHENTICATED_USER_ID
  }

  const userSub = session.user.sub

  if (!userSub.startsWith('auth0|')) {
    throw new PlatformError('Invalid user token')
  }

  const userSubParts = session.user.sub.split('|') as string

  return UserIdSchema.parse(userSubParts[1])
}
